module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_banco_tokyo_sipat_02.837e7d64.jpg";